export const App = {
  Clubs: {},
  Components: {},
  Pages: {},
  Ui: {},
}

window.App = App
